import { LinkInText } from '@crm/components'
import { DayLabel } from '@shared/components'
import { Col, Flex, Row } from 'antd'

import { useTranslation } from 'react-i18next'

import { ActivityLogAvatar } from './ActivityLogAvatar'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

export const ActivityLogNote = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()
  const translatedDescription = useGetTranslatedDescription({ log })

  return (
    <Row justify="space-between" gutter={[16, 16]} align="middle">
      <Col xs={24} xl={12} xxl={12}>
        <LinkInText text={translatedDescription} />
      </Col>

      <Col xs={24} xl={12} xxl={12}>
        <Flex gap={8} justify="end" align="center">
          <ActivityLogAvatar
            user={log?.created_by}
            label={t('task.created_by')}
          />

          <DayLabel date={log.created_at} />
        </Flex>
      </Col>
    </Row>
  )
}
